const Discipline = (plus) => {
  return (
    <>
      <p className="dynamicHtml" dangerouslySetInnerHTML={{ __html: plus.plus }} />
    </>
  );
}

export default Discipline;
